// extracted by mini-css-extract-plugin
export var standaloneTable = "_id-0";
export var standaloneTableWithBodyFill = "_id-1";
export var withExtraHeader = "_id-2";